export default __webpack_public_path__ + "static/media/step4-section3.ae65ad44.png";